import React from 'react';
import { bool } from 'prop-types';
import {
  LogoContainer,
  Logo,
  StepTimeline,
  StepsContainer,
  StepContainer,
  StepCircle,
} from './styles';

const CheckoutHeader = ({ isSignIn }) => (
  <div>
    <LogoContainer>
      <a href="/">
        <Logo src="https://cdn.notonthehighstreet.com/images/header/logos/tag_logo_uk_v2@2x.png?20171017" />
      </a>
    </LogoContainer>
    <StepTimeline>
      {!isSignIn && (
        <StepsContainer>
          <StepContainer>
            <StepCircle filled>1</StepCircle>
            your details
          </StepContainer>
          <StepContainer>
            <StepCircle>2</StepCircle>
            delivery
          </StepContainer>
          <StepContainer>
            <StepCircle>3</StepCircle>
            payment
          </StepContainer>
          <StepContainer>
            <StepCircle>4</StepCircle>
            completed
          </StepContainer>
        </StepsContainer>
      )}
    </StepTimeline>
  </div>
);

CheckoutHeader.propTypes = {
  isSignIn: bool.isRequired,
};

export default CheckoutHeader;
